import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import style from "./index.module.scss";
import MHeader from "components/MHeader";
import PageRadio from "./components/PageRadio";
import { Button } from "antd";
import className from "classnames";
import PageCheckBox from "./components/PageCheckBox";
import PageSubjective from "./components/PageSubjective";
import { BaseQuestionType, PaperProps } from "../../../service";
import AnswerCardModal from "./components/QuestionnaireTopicButtons/components/AnswerCardModal";

interface ExerProps {
    data?: PaperProps;
    oneChange: (questionId: string, value: string) => void;
    moreChange: (questionId: string, value: any) => void;
    oneSave: (questionId: string, value: string) => void;
    moreSave: (questionId: string, value: any) => void;
    onSubmit: () => void;
    headerDom: React.ReactNode; //头部组件dom
    showQuestionnaireBar: boolean;
    questionnaireBarClose: () => void;
}

export default function QuestionnaireModule({
    data,
    oneChange,
    moreChange,
    oneSave,
    moreSave,
    onSubmit,
    headerDom,
    showQuestionnaireBar,
    questionnaireBarClose
}: ExerProps) {
    const history = useHistory();
    const [checked, setChecked] = useState(1); //当前选中

    // const currentData = useMemo(() => {data.topics.find((item,index) => (index + 1) === checked)},[data,checked])
    const currentData = useMemo(
        () => data?.topics.find((item, index) => index + 1 === checked),
        [data, checked]
    );

    function pageOneChange(questionId: string, value: string) {
        oneChange(questionId, value);
    }

    function pageMoreChange(questionId: string, value: any) {
        moreChange(questionId, value);
    }

    function pageOneSave(questionId: string, value: string) {
        oneSave(questionId, value);
    }

    function pageMoreSave(questionId: string, value: any) {
        moreSave(questionId, value);
    }

    return (
        <div className={style.root}>
            <MHeader title="提交问卷" goBack={history.goBack} />
            {/*<div className={style.header}>*/}
            {/*</div>*/}
            {/*共多少题倒计时，点击答题卡按钮*/}
            {headerDom}
            {/*已答，未答试题号提交问卷按钮*/}
            <AnswerCardModal
                onClose={questionnaireBarClose}
                visible={showQuestionnaireBar}
                onSubmit={onSubmit}
                checked={checked}
                data={data?.topics}
                onChange={(val: number) => setChecked(val)}
            />

            <div className={style.body}>
                {currentData &&
                    currentData.queTypeId === BaseQuestionType.SingleChoice &&
                    checked === currentData.index && (
                        <PageRadio data={currentData} oneSave={pageOneSave} />
                    )}
                {currentData &&
                    currentData.queTypeId === BaseQuestionType.MultipleChoice &&
                    checked === currentData.index && (
                        <PageCheckBox
                            data={currentData}
                            moreSave={pageMoreSave}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId === BaseQuestionType.Subjective &&
                    checked === currentData.index && (
                        <PageSubjective
                            data={currentData}
                            oneSave={pageOneSave}
                            oneChange={pageOneChange}
                        />
                    )}
            </div>

            <div className={style.footer}>
                <div className={style.footerDiv}>
                    {currentData && currentData.index !== 1 && (
                        <Button
                            className={className(style.prev, {
                                [style.one]: false
                            })}
                            onClick={() =>
                                setChecked(currentData.index - 1 || 1)
                            }>
                            上一题
                        </Button>
                    )}
                    {currentData &&
                        data &&
                        currentData.index !== data.topics.length && (
                            <Button
                                className={className(style.next, {
                                    [style.one]: false
                                })}
                                onClick={() =>
                                    setChecked(currentData.index + 1 || 1)
                                }>
                                下一题
                            </Button>
                        )}
                    {currentData &&
                        data &&
                        currentData.index === data.topics.length && (
                            <Button
                                className={className(style.next, {
                                    [style.one]: false
                                })}
                                onClick={() => onSubmit()}>
                                提交问卷
                            </Button>
                        )}
                </div>
            </div>
        </div>
    );
}
